@import '../../style/index';

:host {
  display: block;
  transition: height 2000ms;

  .accordeon {
    box-sizing: border-box;
    padding-top: var(--spacings-l);
    border-top: rem-calc(3px) solid var(--colors-dark-base);

    &--article {
      padding-bottom: var(--spacings-m);
      padding-inline: rem-calc(12px);

      @include large-up() {
        padding-inline: var(--spacings-m);
      }

      border-bottom: rem-calc(1px) solid var(--colors-grey-base);
    }
  }

  .accordeon,
  .accordeon--article {
    display: grid;
    grid-template-rows: min-content 0fr;
    transition: grid-template-rows 0.6s ease-in-out;

    &.is-expanded {
      grid-template-rows: min-content 1fr;
    }
  }

  .accordeon-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    border: none;
    background: none;
    padding: 0;
    margin: 0;
    box-shadow: none;
    font: inherit;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    color: inherit;
    text-align: inherit;
    line-height: inherit;
  }

  .accordeon-content {
    overflow: hidden;

    p {
      @include copy-primary();

      color: var(--colors-dark-light);
    }
  }
}
